<form class="popupForm" [formGroup]="componentForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      <ng-container *ngIf="mode == 'show_purchases'">{{'user_services_title' | GetLabelPipe}}</ng-container>
      <ng-container *ngIf="mode == 'show_proposals'">{{'user_proposals_title' | GetLabelPipe}}</ng-container>
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke flex-justify-start" style="display: flex !important; height: 500px;">
      <div class="internal-spinner" *ngIf="state === 'loading'">
        <svg class="spinner" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
        </svg>
      </div>
      <div *ngIf="state === 'error'">
        >.< error. <br>{{errMsg}}
      </div>
      <ng-container *ngIf="state==='default'">
        <div *ngIf="purchases && purchases.length"
             style="margin: 20px 0px; font-size: 0.8em;">
          <ng-container *ngIf="mode == 'show_purchases'">{{profile.shipping_name}} has {{purchases.length}} services.</ng-container>
          <ng-container *ngIf="mode == 'show_proposals'">{{profile.shipping_name}} has {{purchases.length}} proposals.</ng-container>
        </div>
        <div  *ngIf="!purchases || !purchases.length"
              style="margin: 20px 0px; font-size: 0.8em;">
          <ng-container *ngIf="mode == 'show_purchases'">{{profile.shipping_name}} has no services.</ng-container>
          <ng-container *ngIf="mode == 'show_proposals'">{{profile.shipping_name}} has no proposals.</ng-container>
        </div>

        <div *ngIf="!purchases || !purchases.length" class="flex-row-center flex-justify-center" style="height: 80%">
          <button mat-raised-button class="toolbar-top-btn new-folder-btn" color="accent"
                  [disabled]="pickItemsLoading" (click)="pickService()">
            <mat-icon>add</mat-icon>
            <div style="display: inline; margin-left: 10px" *ngIf="mode == 'show_purchases'">{{'add_new_service'|GetLabelPipe}}</div>
            <div style="display: inline; margin-left: 10px" *ngIf="mode == 'show_proposals'">{{'add_new_proposal'|GetLabelPipe}}</div>
          </button>
        </div>
        <div *ngIf="purchases && purchases.length" class="events-listing-container listing-full-size" style="margin-top: 20px !important;">

          <mat-accordion class="services-accordion" multi>
            <mat-expansion-panel *ngFor="let listItem of purchases; let idx = index">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div style="margin-bottom: 12px;">{{(idx+1)}}. {{listItem.name}} (#{{listItem['itemFullData']['reference']}})</div>
                  <div class="subrow">
                    <div style="width: 50px;">Created:</div>
                    <div>{{listItem['itemFullData']['created_time']*1000 | fsDate}}</div>
                  </div>
                  <div class="subrow" *ngIf="listItem['itemFullData']['never_expire'] == 'N'">
                    <div style="width: 50px;">Expiry:</div>
                    <div>{{listItem['itemFullData']['expire_time']*1000 | fsDate}}</div>
                  </div>
                </mat-panel-title>
                <mat-panel-description>
                  <div style="margin-bottom: 12px;">Included services:</div>
                  <div class="subservice"
                       *ngFor="let serviceItem of listItem['itemFullData']['usage']; let jdx = index">
                    {{serviceItem['name']}}: {{serviceItem['used_qty']}}/{{serviceItem['qty']}}.
                    <ng-container *ngIf="serviceItem['trainer_name']">
                      <br/>Trainer: {{serviceItem['trainer_name']}}.
                    </ng-container>
                  </div>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <br/>
              <div>
                Expiry date:
              </div>
              <mat-form-field appearance="outline" color="accent">
                <mat-label>Expire date</mat-label>
                <input matInput type="text" [matDatepicker]="dp1"
                       (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()"
                       formControlName="purchaseExpiryControl_{{idx}}">
                <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
                <mat-datepicker #dp1 disabled="false"></mat-datepicker>
              </mat-form-field>
              <button mat-raised-button color="accent" [disabled]="pickItemsLoading"
                      *ngIf="mode == 'show_proposals'"
                      style="margin-left: 80px;"
                      (click)="showPromoPopup(idx)">
                <ng-container *ngIf="!listItem['itemFullData']['proposal_message']">{{'Send promotion message' | GetLabelPipe}}</ng-container>
                <ng-container *ngIf="listItem['itemFullData']['proposal_message']">{{'Re-Send promotion message' | GetLabelPipe}}</ng-container>
              </button>

              <ng-container *ngIf="mode == 'show_proposals'">
                <br/>
                <br/>
                <div>
                  Custom/List prices:
                </div>
                <mat-form-field appearance="outline" color="accent" style="width: 130px;">
                  <mat-label>Custom price</mat-label>
                  <input matInput type="number" min="0"
                         (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()"
                         formControlName="purchaseCustomPriceControl_{{idx}}">
                </mat-form-field>
                <mat-form-field appearance="outline" color="accent" style="width: 130px;">
                  <mat-label>List price</mat-label>
                  <input matInput type="number" min="0"
                         (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()"
                         formControlName="purchaseListPriceControl_{{idx}}">
                </mat-form-field>
              </ng-container>

              <ng-container *ngFor="let serviceItem of listItem['itemFullData']['usage']; let jdx = index">
                <br/>
                <br/>
                <div>
                  {{serviceItem['name']}}:<ng-container *ngIf="serviceItem['another_usage_reference']"> (#{{serviceItem['another_usage_reference']}})</ng-container>
                </div>
                <mat-form-field appearance="outline" color="accent" style="width: 100px;">
                  <mat-label>Used qty</mat-label>
                  <input matInput type="number" min="0"
                         (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()"
                         formControlName="packageUsageQtyControl_{{idx}}_{{jdx}}">
                </mat-form-field>
                <mat-form-field appearance="outline" color="accent" style="width: 100px;">
                  <mat-label>Limit qty</mat-label>
                  <input matInput type="number" min="0" [disabled]="true"
                         (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()"
                         formControlName="packageLimitQtyControl_{{idx}}_{{jdx}}">
                </mat-form-field>
              </ng-container>

              <mat-action-row class="flex-justify-start error-color" *ngIf="errorMessages[idx]">
                {{errorMessages[idx]}}
              </mat-action-row>

              <mat-action-row class="flex-justify-start">
                <button mat-raised-button color="accent" [disabled]="pickItemsLoading"
                        (click)="saveService(idx)">
                  {{'save' | GetLabelPipe}}
                </button>
                <button mat-button color="warn" [disabled]="pickItemsLoading"
                        (click)="deleteService(idx)">
                  {{'delete' | GetLabelPipe}}
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </mat-accordion>

        </div>
        <br>
      </ng-container>

    </mat-dialog-content>
    <div *ngIf="purchases && purchases.length" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
        {{'cancel'|GetLabelPipe}}
      </button>
      <button type="submit" class="widerButton font16" mat-raised-button color="accent"
              [disabled]="state === 'loading'" [disabled]="pickItemsLoading" (click)="pickService()">
        <ng-container *ngIf="mode == 'show_purchases'">{{'pick_new_service'|GetLabelPipe}}</ng-container>
        <ng-container *ngIf="mode == 'show_proposals'">{{'pick_new_proposal'|GetLabelPipe}}</ng-container>
      </button>
    </div>
  </div>
</form>
